module.exports = __webpack_public_path__ + "static/android-chrome-512x512-cf10d02054bbfb8af2cfd9f16a0b00ee.png";